/* eslint-disable */
// src/layouts/local/inactive/data/inactiveLocalTableData.js

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";

const formatDateOnly = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("es-UY");
};

export default function inactiveLocalTableData({ localsDetails, onDetails, darkMode = false }) {
  const columns = [
    { Header: "Local", accessor: "Name", align: "left" },
    { Header: "Fechas", accessor: "Dates", align: "left" },
  ];

  const buildLocalRow = (l) => {
    const destination = onDetails?.(l);
    const createdAt = formatDateOnly(l.CreatedAt ?? l.createdAt);
    const closedAt = formatDateOnly(l.ClosedAt ?? l.closedAt);

    return {
      Name: (
        <MDBox
          sx={{ fontSize: "18px", lineHeight: 1.5, whiteSpace: "normal", overflowWrap: "anywhere" }}
        >
          {destination ? (
            <Box
              component={Link}
              to={destination.pathname}
              state={destination.state}
              sx={{
                fontSize: "18px",
                lineHeight: 1.5,
                color: darkMode ? "#82BEFF" : "info.main",
                textDecoration: "underline",
                textUnderlineOffset: "2px",
                overflowWrap: "anywhere",
                "&:hover": { color: darkMode ? "#B7DAFF" : "info.dark" },
                "&:focus-visible": {
                  outline: "2px solid",
                  outlineColor: darkMode ? "#82BEFF" : "info.main",
                  outlineOffset: 2,
                },
              }}
            >
              {l.Name}
            </Box>
          ) : (
            <Box component="span" sx={{ fontSize: "18px", overflowWrap: "anywhere" }}>
              {l.Name}
            </Box>
          )}
          {"\u00a0\u00a0·\u00a0\u00a0"}
          <MDTypography
            component="span"
            variant="body2"
            fontWeight="regular"
            color="dark"
            opacity={0.8}
            sx={{ display: "inline", fontSize: "18px", lineHeight: 1.5, overflowWrap: "anywhere" }}
          >
            {l.Person?.Name || "Sin dueño"}
          </MDTypography>
        </MDBox>
      ),
      Dates: (
        <MDBox sx={{ fontSize: "18px", lineHeight: 1.5, whiteSpace: "nowrap" }}>
          <span aria-hidden="true">
            {createdAt} → {closedAt}
          </span>
          <MDBox
            component="span"
            sx={{
              position: "absolute",
              width: 1,
              height: 1,
              p: 0,
              m: -1,
              overflow: "hidden",
              clip: "rect(0, 0, 0, 0)",
              clipPath: "inset(50%)",
              whiteSpace: "nowrap",
              border: 0,
            }}
          >
            Alta: {createdAt}; cierre: {closedAt}
          </MDBox>
        </MDBox>
      ),
    };
  };

  const rows = (localsDetails || []).map((l) => buildLocalRow(l));

  return {
    columns,
    rows,
  };
}
